import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FormLogin from '../forms/form-login/form-login.vue';
import VueRecaptcha from 'vue-recaptcha';

@Component({
  name: 'bpc-modal-login',
  components: {
    'bpc-form-login': FormLogin,
    'vue-recaptcha': VueRecaptcha,
  },
})
export default class ModalLogin extends Vue {
  $refs: {
    formLogin: InstanceType<typeof FormLogin> & {
      login(): Promise<boolean>;
    };
    recaptcha: InstanceType<typeof VueRecaptcha> & { reset(): void };
  };

  @Prop(Boolean) show: boolean;
  @Prop({ type: String, default: 'login-modal' }) readonly modalId: string;
  @Prop({ type: String, default: 'global.modals.login.title' }) readonly title: string;
  @Prop({ type: String, default: 'global.modals.login.body' }) readonly body: string;
  @Prop({ type: String, default: 'global.modals.login.error-message' })
  readonly loginErrorMessage: string;

  recaptchaCode: string = null;
  sendingLogin: boolean = false;
  recaptchaVerified: boolean = false;

  get withRecaptcha(): boolean {
    return !!process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  }

  get sitekey(): string {
    return process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6Le_IMcZAAAAAGFibon8pJAIB809CODlqFdHRowK';
  }

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  showErrorMessage: boolean = false;
  openModal() {
    this.$bvModal.show(this.modalId);
    this.$emit('on-open-modal');
  }

  onResetRecaptcha() {
    this.sendingLogin = false;
    this.recaptchaVerified = false;
    this.recaptchaCode = null;
    this.$refs.recaptcha.reset();
    this.$store.commit('auth/restartedRecaptcha');
  }

  onVerify(response) {
    this.recaptchaCode = response;
    this.recaptchaVerified = true;
  }

  onExpired() {
    this.recaptchaVerified = false;
    this.recaptchaCode = null;
  }

  async login(): Promise<boolean> {
    // login to the system
    this.sendingLogin = true;

    const res = await this.$refs.formLogin.login();
    if (res) {
      this.$emit('success-login', true);
      this.sendingLogin = false;

      this.onCloseModal();
      return res;
    } else {
      this.showErrorInLogin();
      this.sendingLogin = false;
      return false;
    }
  }

  showErrorInLogin() {
    this.showErrorMessage = true;
  }

  onCloseModal() {
    this.$emit('on-close-modal');
  }

  closeModal() {
    this.$bvModal.hide(this.modalId);
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  @Watch('show')
  onShowChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
